__turbopack_context__.v({
  "button": "style-module-scss-module__NsMawG__button",
  "button_hidden": "style-module-scss-module__NsMawG__button_hidden",
  "item": "style-module-scss-module__NsMawG__item",
  "item_active": "style-module-scss-module__NsMawG__item_active",
  "label": "style-module-scss-module__NsMawG__label",
  "label_mb": "style-module-scss-module__NsMawG__label_mb",
  "slideInFromLeft": "style-module-scss-module__NsMawG__slideInFromLeft",
  "slideInFromTop": "style-module-scss-module__NsMawG__slideInFromTop",
  "subtitle": "style-module-scss-module__NsMawG__subtitle",
  "subtitle_hidden": "style-module-scss-module__NsMawG__subtitle_hidden",
  "title": "style-module-scss-module__NsMawG__title",
  "title_hidden": "style-module-scss-module__NsMawG__title_hidden",
});
